// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

export const CUSTOM_SCENARIO_PARAMETERS_OPTIONS = [];

export const CUSTOM_PARAMETER_GROUPS_OPTIONS = [];
